import { useContext } from "react";
import { ConfigContext } from "@ob/mantis/contexts/ConfigContext";

// ==============================|| CONFIG - HOOKS ||============================== //

const useConfig = () => useContext(ConfigContext);

export default useConfig;
